/*eslint-disable*/
import logo72x72 from "./APi-logo-clear-back72x72.png";
import logo96x96 from "./APi-logo-clear-back96x96.png";
import logo192x192 from "./API_LOGO_Transparent_logo_RedLine_1024x1024PX.png";
import logo138x75black from "./API-logo-clear-back-165x90.png";
import logo138x75white from "./API-logo-ligh-blue-back138x75.png";
import logo165x90white from "./API-logo-light-blue-back-165x90.png";
import logo1024x1024 from "./APi-logo-light-blue-back1024x1024.png";
import API_Square_Logo_320px from "./API_Square_Logo_320px.png";
import intro from "./intro.png";
import bg from "./bg.png";

export default {
  logo72x72,
  logo96x96,
  logo192x192,
  logo138x75black,
  logo138x75white,
  logo1024x1024,
  logo165x90white,
  API_Square_Logo_320px,
  intro,
  bg,
};
